module.exports = __webpack_public_path__ + "assets/img/img146.b50133fa.png";